import {
  Field,
  RadioGroup as HRadioGroup,
  Label,
  Radio,
} from '@headlessui/react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface Props<T extends string> {
  options: Array<{ label: string; value: T }>;
  selected: T | undefined;
  setSelected: (value: T) => void;
  label?: string;
  error?: string;
}

export function RadioGroup<T extends string>({
  options,
  selected,
  setSelected,
  label,
  error
}: Props<T>) {
  return (
    <div className="space-y-2">
      {label && (
        <span className="text-body-medium font-semibold block">{label}</span>
      )}
      <HRadioGroup
        value={selected ?? '' as T}
        onChange={setSelected}
        className="flex flex-col"
      >
        {options.map((opt) => (
          <Field
            key={opt.value}
            className="flex group items-center gap-x-2 my-2.5"
          >
            <Radio
              value={opt.value}
              className="group/radio flex size-6 items-center justify-center rounded-full border-2 group-hover:border-secondary-100 border-secondary-300"
            >
              <span className="invisible size-3 rounded-full bg-secondary-300 group-data-checked/radio:visible group-hover:bg-secondary-100" />
            </Radio>
            <Label>{opt.label}</Label>
          </Field>
        ))}
      </HRadioGroup>
      {error && (
        <div className="flex space-x-1.5 items-start mt-2">
          <InformationCircleIcon className="shrink-0 size-4 text-red-300 mt-[3px]" />
          <span className="text-body-smallest text-red-300">{error}</span>
        </div>
      )}
    </div>
  );
}
